/**
 * Import pauthDetection listener setup and initialize with web's listener middleware
 */
import { getLogger } from 'app-components/utils/core';
import { setupPauthDetectionListener } from 'app-components/store/listeners/pauthDetection';

import { startAppListening } from './listenerMiddleware';

const log = getLogger('storeListeners/pauthDetection');

log.info('Importing pauthDetection listener...');

// Initialize the pauthDetection listener with web's startAppListening
setupPauthDetectionListener(startAppListening);

log.info('pauthDetection listener registered');
